import React from 'react';
import SkillCard from './SkillCard';
import {useCharacter} from "./CharacterProvider";

const SkillList = ({
                       availableSkills,
                       skillsetMap,
                       getSkillCost,
                       onIncrement,
                       onDecrement,
                       onRemove,
                   }) => {
    const {currentCharacter, setCurrentCharacter} = useCharacter();

    if (!currentCharacter || !currentCharacter.skills) return <p>No skills assigned.</p>;

    const skillsArray = Array.isArray(currentCharacter.skills) ? currentCharacter.skills : [];
    if (skillsArray.length === 0) return <p>No skills assigned.</p>;

    const isSkillPrimary = (skill) => {
        return skill && skill.skillset && (Number(skill.skillset) === Number(currentCharacter.skillsetPrimary) || skill.secondaryBaseCost == null);
    };

    const isSkillSecondary = (skill) => {
        return skill && skill.skillset && Number(skill.skillset) === Number(currentCharacter.skillsetSecondary);
    };

    // Group the skills by skillset or source.
    const groupedSkills = skillsArray.reduce((acc, skill) => {
        const baseSkill = availableSkills.find(s => s.skillId === skill.skillId);
        /*const groupKey =
            baseSkill && baseSkill.skillset !== undefined
                ? String(baseSkill.skillset)
                : baseSkill && baseSkill.source === 'transform'
                    ? 'transform'
                    : 'unknown';*/
        // Determine the group key
        let groupKey;
        if (baseSkill && baseSkill.primaryBaseCost === 0) {
            groupKey = 'static';
        } else if (baseSkill && baseSkill.skillset !== undefined) {
            groupKey = String(baseSkill.skillset);
        } else if (baseSkill && baseSkill.source === 'transform') {
            groupKey = 'transform';
        } else {
            groupKey = 'unknown';
        }

        if (!acc[groupKey]) {
            acc[groupKey] = [];
        }

        if (isSkillPrimary(baseSkill)) {
            skill.baseCost = baseSkill.primaryBaseCost;
            skill.incrementCost = baseSkill.primaryIncrementCost;
        } else if (isSkillSecondary(baseSkill)) {
            skill.baseCost = baseSkill.secondaryBaseCost;
            skill.incrementCost = baseSkill.secondaryIncrementCost;
        } else if (baseSkill) {
            skill.baseCost = baseSkill.tertiaryBaseCost;
            skill.incrementCost = baseSkill.tertiaryIncrementCost;
        }
        acc[groupKey].push({ ...baseSkill, ...skill });
        return acc;
    }, {});

    const localSkillsetMap = {
        ...skillsetMap,
        static: 'Static'
    };

    // Sort the group keys alphabetically by label.
    const sortedGroupKeys = Object.keys(groupedSkills).sort((a, b) => {
        // Always push 'static' to the end
        if (a === 'static' && b !== 'static') return 1;
        if (b === 'static' && a !== 'static') return -1;
        const labelA = a === 'transform' ? 'Transform Abilities' : (localSkillsetMap?.[a] || '').toUpperCase();
        const labelB = b === 'transform' ? 'Transform Abilities' : (localSkillsetMap?.[b] || '').toUpperCase();
        return labelA.localeCompare(labelB);
    });

    return (
        <div className="skills-list">
            {sortedGroupKeys.map((groupKey, index) => (
                <div key={`group-${index}`} className="floating-label skills-list-form-group">
                    <div className="skill-group">
                        <div className="group-header">
                            {/*<h4>{groupKey === 'transform' ? 'Transform Abilities' : skillsetMap?.[groupKey] || groupKey}</h4>*/}
                            {groupKey === 'transform' ? 'Transform Abilities' : localSkillsetMap?.[groupKey] || groupKey}
                        </div>
                        <div className="group-skills">
                            {groupedSkills[groupKey]
                                .sort((s1, s2) => (s1.name || '').localeCompare(s2.name || ''))
                                .map((skill) => (
                                    <SkillCard
                                        key={skill.skillId || skill.name}
                                        skill={skill}
                                        spCost={getSkillCost(skill)}
                                        getSkillCost={getSkillCost}
                                        onIncrement={onIncrement}
                                        onDecrement={onDecrement}
                                        onRemove={onRemove}
                                        description={skill.description}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SkillList;
